import { useSelector } from "react-redux";

import { getUserDisplayName } from "../authReducer";

export const useUserDisplayName = () => useSelector(getUserDisplayName);
